import angular from 'angular';

import reportsDataService from 'app/services/data/reports.data.service';
import directive from './view-report.directive';
import controller from './view-report.directive.controller';

export default angular.module('app.components.global.viewReport', [
  reportsDataService
])
  .directive('viewReport', directive)
  .controller('ViewReportDirectiveController', controller)
  .name;

console.log('app.components.global.viewReport created');
